import React, { useState } from "react";
import BooksFooter from "../components/BooksFooter";
import BooksNavbar from "../components/BooksNavbar";

const Books = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  return (
    <div className="overflow-x-hidden">
      {/* Hero Section */}
      <section
        className="relative min-h-[90vh] bg-cover bg-center"
        style={{ backgroundImage: "url('/books-hero.png')" }}
      >
        {/* overlay */}
        <div className="absolute inset-0 bg-black/40"></div>

        {/* navbar */}
        {/* <nav className="absolute top-0 left-0 right-0 z-20 px-6 py-4 text-white">
          <div className="flex justify-between items-center max-w-7xl mx-auto w-full px-4">
            <div className="font-semibold text-lg">
              THINK BEFORE YOU THINK
            </div>

            <div className="hidden md:flex items-center space-x-4 text-sm">
              <a href="/books">THE BOOK</a>
              <a href="/books/science">THE SCIENCE</a>
              <a href="/books/about">ABOUT ADRIAN</a>
              <a href="/books/news">NEWS</a>
              <a href="/books/contact">CONTACT</a>
              <a
                href="/books/preorder"
                className="bg-[#D4AF37] text-black px-4 py-2 font-semibold"
              >
                PREORDER
              </a>
            </div>

            <button
              className="md:hidden text-white text-2xl"
              onClick={() => setMenuOpen(!menuOpen)}
            >
              ≡
            </button>
          </div>

          
          {menuOpen && (
            <div className="absolute top-full left-0 w-full bg-black text-white flex flex-col items-center py-4 space-y-4 md:hidden">
              <a href="/books">THE BOOK</a>
              <a href="/books/science">THE SCIENCE</a>
              <a href="/books/about">ABOUT ADRIAN</a>
              <a href="/books/news">NEWS</a>
              <a href="/books/contract">CONTACT</a>

              <a
                href="/books/preorder"
                className="bg-[#D4AF37] text-black px-4 py-2 font-semibold"
              >
                PREORDER
              </a>
            </div>
          )}
        </nav> */}

        <BooksNavbar textColor="white" />

        {/* hero text */}
        <div className="relative z-10 min-h-[90vh] flex items-center">
          <div className="w-full max-w-7xl mx-auto px-12">
            <div className="max-w-md text-white">
              <h1
                className="text-3xl md:text-4xl leading-tight"
                style={{ fontFamily: "Playfair Display, serif" }}
              >
                <span className="block text-white sm:text-black">
                  The part of
                </span>
                <span className="block text-white sm:text-black">
                  your brain you
                </span>
                <span className="block text-white sm:text-black">
                  rely on most...
                </span>
                <span className="block text-[#D4AF37]">is the one you</span>
                <span className="block text-[#D4AF37]">understand least</span>
              </h1>
              <p className="mt-6 text-sm md:text-base text-white max-w-sm">
                A new book exploring the hidden science of consciousness,
                awareness, and the brain systems that shape how we think.
              </p>

              {/* <div className="mt-6 flex gap-4"> */}
              <div className="mt-6 flex flex-wrap gap-2 sm:gap-4 items-center">
                <a
                  href="https://wwnorton.com/books/9781324075165"
                  target="_blank"
                  rel="nooperner noreferrer"
                  // className="bg-[#D4AF37] text-black px-5 py-2 text-sm font-semibold "
                  className="bg-[#D4AF37] text-black px-3 sm:px-5 py-2 text-xs sm:text-sm font-semibold whitespace-nowrap leading-none"
                >
                  Order
                </a>

                <a
                  href="/books/science"
                  // className="border border-white text-white px-5 py-2 text-sm font-semibold"
                  className="border border-white text-white px-3 sm:px-5 py-2 text-xs sm:text-sm font-semibold whitespace-nowrap leading-none"
                >
                  The Science
                </a>

                <a
                  href="https://www.faber.co.uk/product/9781783352982-think-before-you-think/"
                  target="_blank"
                  rel="noopener noreferrer"
                  // className="bg-[#D4AF37] text-black px-5 py-2 text-sm font-semibold"
                  className="bg-[#D4AF37] text-black px-3 sm:px-5 py-2 text-xs sm:text-sm font-semibold whitespace-nowrap leading-none"
                >
                  UK Edition
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* executive function section */}
      <section className="bg-white py-12">
        {/* <div className="max-w-7xl mx-auto px-6 grid lg:grid-cols-2 gap-10 items-center"> */}
        <div className="max-w-7xl mx-auto px-6 grid lg:grid-cols-[0.85fr_1.15fr] gap-8 items-center">
          {/* left text */}
          <div>
            <p
              className="text-xs tracking-widest text-gray-500 mb-4"
              style={{ fontFamily: "Playfair Display, serif" }}
            >
              WHAT IS EXECUTIVE FUNCTION?
            </p>

            <h2
              className="text-3xl md:text-4xl text-black leading-tight mb-4"
              style={{ fontFamily: "Playfair Display, serif" }}
            >
              The invisible system that runs your mind.
            </h2>

            <p
              className="text-gray-600 mb-6 max-w-md"
              style={{ fontFamily: "Playfair Display, serif" }}
            >
              It's the set of mental skills that let you plan, focus, remember,
              juggle tasks and control your impulses.
            </p>

            <p
              className="text-gray-600 mb-6 max-w-md"
              style={{ fontFamily: "Playfair Display, serif" }}
            >
              When it works, life feels effortless. When it falters, everything
              feels harder.
            </p>

            {/* <p
              className="text-gray-600 text-sm leading-relaxed"
              style={{ fontFamily: "Playfair Display, serif" }}
            >
              Executive function is not just about productivity.
              It shapes who we are — our decisions, our relationships,
              our sense of self and our place in the world.
            </p> */}

            <a
              href="/books/science"
              className="text-sm font-semibold text-[#D4AF37]"
              style={{ fontFamily: "Playfair Display, serif" }}
            >
              FIND OUT MORE →
            </a>
          </div>

          {/* right brain image */}
          {/* <div className="relative flex justify-center">
            <img
            src="/brain-transparent.png"
            alt="Brain"
            className="w-[350px] sm:w-[380px] md:w-[450px]"
            />

            <div className="absolute right-0 top-4 flex items-center">
              <div className="w-16 h-[1px] bg-gray-400"></div>
              <span className="text-xs text-gray-600 mr-2">
                Planning ahead
              </span>
            </div>

            <div className="absolute right-0 top-10 flex items-center">
              <div className="w-16 h-[1px] bg-gray-400"></div>
              <span className="text-xs text-gray-600 mr-2">
                Staying focused
              </span>
            </div>

            <div className="absolute right-0 top-16 flex items-center">
              <div className="w-16 h-[1px] bg-gray-400"></div>
              <span className="text-xs text-gray-600 mr-2">
                Remembering
              </span>
            </div>

            <div className="absolute right-0 top-32 flex items-center">
              <div className="w-16 h-[1px] bg-gray-400"></div>
              <span className="text-xs text-gray-600 mr-2">
                Resisting distractions
              </span>
            </div>

            <div className="absolute right-0 top-40 flex items-center">
              <div className="w-16 h-[1px] bg-gray-400"></div>
              <span className="text-xs text-gray-600 mr-2">
                Managing emotions
              </span>
            </div>

            <div className="absolute right-0 top-48 flex items-center">
              <div className="w-16 h-[1px] bg-gray-400"></div>
              <span className="text-xs text-gray-600 mr-2">
                Solving problems
              </span>
            </div>

          </div> */}

          {/* right brain image */}
          {/* right brain image */}

          {/* right brain image */}
          {/* right brain image */}
          <div className="relative mt-10 lg:mt-0 flex justify-center w-full overflow-visible">
            <div className="relative w-full max-w-[720px] xl:translate-x-24">
              <img
                src="/brain-transparent-1.png"
                alt="Brain"
                className="w-[58%] sm:w-[60%] md:w-[62%] lg:w-[64%]"
              />

              {/* labels */}
              {/* <div className="absolute top-[13%] left-[42%] right-0 space-y-3"> */}
              <div className="absolute top-[13%] left-[42%] right-0 space-y-0.5 sm:space-y-2 md:space-y-3">
                {[
                  "Planning ahead",
                  "Staying focused",
                  "Remembering",
                  "Resisting distractions",
                  "Managing emotions",
                  "Solving problems",
                ].map((label) => (
                  <div key={label} className="flex items-center w-full">
                    <div className="w-20 md:w-28 lg:w-36 h-[1px] bg-gray-500 flex-shrink-0"></div>
                    <span
                      // className="text-[10px] md:text-xs text-gray-600 ml-2 whitespace-nowrap"
                      className="text-[9px] sm:text-[10px] md:text-xs text-gray-600 ml-2 whitespace-nowrap leading-tight"
                      style={{ fontFamily: "Playfair Display, serif" }}
                    >
                      {label}
                    </span>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* <div className="relative mt-10 md:mt-0 flex justify-center lg:justify-start overflow-visible">

            <img
              src="/brain-transparent-1.png"
              alt="Brain"
              className="w-[350px] sm:w-[450px] md:w-[550px] lg:w-[650px]"
            />


            
            <div className="absolute top-8 left-[58%] space-y-4">
              <div className="flex items-center">
                <div className="w-28 md:w-40 h-[1px] bg-gray-500"></div>
                <span
                  className="text-xs text-gray-600 ml-2 whitespace-nowrap"
                  style={{ fontFamily: "Playfair Display, serif" }}
                >
                  Planning ahead
                </span>
              </div>

              <div className="flex items-center">
                <div className="w-28 md:w-40 h-[1px] bg-gray-500"></div>
                <span
                  className="text-xs text-gray-600 ml-2 whitespace-nowrap"
                  style={{ fontFamily: "Playfair Display, serif" }}
                >
                  Staying focused
                </span>
              </div>

              <div className="flex items-center">
                <div className="w-28 md:w-40 h-[1px] bg-gray-500"></div>
                <span
                  className="text-xs text-gray-600 ml-2 whitespace-nowrap"
                  style={{ fontFamily: "Playfair Display, serif" }}
                >
                  Remembering
                </span>
              </div>

              <div className="flex items-center">
                <div className="w-28 md:w-40 h-[1px] bg-gray-500"></div>
                <span
                  className="text-xs text-gray-600 ml-2 whitespace-nowrap"
                  style={{ fontFamily: "Playfair Display, serif" }}
                >
                  Resisting distractions
                </span>
              </div>

              <div className="flex items-center">
                <div className="w-28 md:w-40 h-[1px] bg-gray-500"></div>
                <span
                  className="text-xs text-gray-600 ml-2 whitespace-nowrap"
                  style={{ fontFamily: "Playfair Display, serif" }}
                >
                  Managing emotions
                </span>
              </div>

              <div className="flex items-center">
                <div className="w-28 md:w-40 h-[1px] bg-gray-500"></div>
                <span
                  className="text-xs text-gray-600 ml-2 whitespace-nowrap"
                  style={{ fontFamily: "Playfair Display, serif" }}
                >
                  Solving problems
                </span>
              </div>
            </div>
          </div>



        </div> */}
        </div>
      </section>

      {/* when it goes wrong section */}
      <section className="relative">
        {/* <div className="text-center py-6">
          <p
            className="text-xs tracking-[0.3em] text-[#D4AF37]"
            style={{ fontFamily: "Playfair Display, serif" }}
          >
            WHEN IT GOES WRONG
          </p>
        </div> */}

        <div className="absolute top-4 left-1/2 -translate-x-1/2 z-20 text-center">
          <p
            className="text-lg tracking-[0.3em] text-white uppercase"
            style={{ fontFamily: "Playfair Display, serif" }}
          >
            WHEN IT GOES WRONG
          </p>
        </div>

        <div className="grid md:grid-cols-3">
          {/* card 1 */}
          <div
            className="relative min-h-[320px] bg-cover bg-center"
            style={{ backgroundImage: "url('/keys.png')" }}
          >
            <div className="absolute inset-0 bg-black/50"></div>

            {/* <div className="relative z-10 h-full flex flex-col justify-end p-8 text-white"> */}
            <div className="absolute inset-0 z-10 flex flex-col justify-end p-8 text-white">
              <h3 className="text-xl mb-3">Everyday lapses</h3>
              <p className="text-sm mb-4">
                Keys in the hand, mind elsewhere. Small failures that cause big
                frustrations.
              </p>
              <a
                href="/books/science/everyday-lapses"
                className="text-sm text-[#D4AF37] font-semibold"
              >
                LEARN MORE →
              </a>
            </div>
          </div>

          {/* card 2 */}
          <div
            className="relative min-h-[320px] bg-cover bg-center"
            style={{ backgroundImage: "url('/adhd.png')" }}
          >
            <div className="absolute inset-0 bg-black/55"></div>

            {/* <div className="relative z-10 h-full flex flex-col justify-end p-8 text-white"> */}
            {/* <div className="relative z-10 h-full flex flex-col justify-end p-8 text-white"> */}
            <div className="absolute inset-0 z-10 flex flex-col justify-end p-8 text-white">
              <h3 className="text-xl mb-3">ADHD and distraction</h3>
              <p className="text-sm mb-4">
                When focus, organization and self-control become an uphill
                struggle.
              </p>
              <a
                href="/books/science/adhd"
                className="text-sm text-[#D4AF37] font-semibold"
              >
                LEARN MORE →
              </a>
            </div>
          </div>

          {/* card 3 */}
          <div
            className="relative min-h-[320px] bg-cover bg-center"
            style={{ backgroundImage: "url('/dementia-tree.png')" }}
          >
            <div className="absolute inset-0 bg-black/45"></div>

            {/* <div className="relative z-10 h-full flex flex-col justify-end p-8 text-white"> */}
            {/* <div className="relative z-10 h-full flex flex-col justify-end p-8 text-white"> */}
            <div className="absolute inset-0 z-10 flex flex-col justify-end p-8 text-white">
              <h3 className="text-xl mb-3">Dementia</h3>
              <p className="text-sm mb-4">
                When the systems that control our minds slowly begin to fade.
              </p>
              <a
                href="/books/science/dementia"
                className="text-sm text-[#D4AF37] font-semibold"
              >
                LEARN MORE →
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* why it matters section */}
      {/* <section className="bg-[#f7f5f2] py-14">
        <div className="max-w-7xl mx-auto px-6 grid md:grid-cols-3 items-center gap-8">

          
          <div className="hidden md:flex justify-start">
            <img
              src="/man-tree-2.png"
              alt="Tree sketch"
              className="w-[220px] opacity-70"
            />
          </div>

          
          <div className="text-center">
            <h2
              className="text-3xl text-black mb-4"
              style={{ fontFamily: "Playfair Display, serif" }}
            >
              Why it matters
            </h2>

            <p
              className="text-gray-600 text-sm leading-relaxed"
              style={{ fontFamily: "Playfair Display, serif" }}
            >
              Executive function is not just about productivity.
              It shapes who we are — our decisions, our relationships,
              our sense of self and our place in the world.
            </p>

            <div className="w-16 h-[1px] bg-[#D4AF37] mx-auto mt-6"></div>
          </div>

          
          <div className="hidden md:flex justify-end">
            <img
              src="/birds-mountains.png"
              alt="Mountain sketch"
              className="w-[240px] opacity-70"
            />
          </div>

        </div>
      </section> */}

      {/* about the author section */}
      <section className="bg-white py-8">
        <div className="max-w-7xl mx-auto px-6 grid md:grid-cols-3 gap-10 items-center">
          {/* left image */}
          <div className="flex justify-center md:justify-start">
            <img
              src="/Owen-24-final.jpg"
              alt="Adrian Owen"
              className="w-[260px] md:w-[300px] rounded-md"
            />
          </div>

          {/* middle text */}
          <div>
            <p className="text-xs tracking-widest text-gray-500 mb-3">
              ABOUT THE AUTHOR
            </p>

            <h3
              className="text-2xl md:text-3xl mb-4"
              style={{ fontFamily: "Playfair Display, serif" }}
            >
              Adrian Owen
            </h3>

            <p className="text-gray-600 text-sm mb-4 leading-relaxed">
              For over three decades, Adrian Owen has explored how the brain
              supports awareness, thought and decision-making — often in the
              most extreme conditions imaginable.
            </p>

            <p className="text-gray-600 text-sm mb-6 leading-relaxed">
              His research has taken him to the frontiers of neuroscience, from
              disorders of consciousness to detecting awareness in patients once
              thought to be entirely unresponsive.
            </p>

            <a
              href="/books/about"
              className="text-sm font-semibold text-[#D4AF37]"
            >
              MORE ABOUT ADRIAN →
            </a>
          </div>

          {/* right book cover */}
          <div className="flex justify-center md:justify-end">
            <img
              src="/my-book-cover-transparent.png"
              alt="Think Before You Think Book"
              className="w-[180px] md:w-[220px]"
            />
          </div>
        </div>
      </section>

      {/* praise section */}
      <section className="bg-[#f5f3ef] py-8">
        <div className="max-w-7xl mx-auto px-6">
          <p
            className="text-center text-md tracking-widest text-[#D4AF37] mb-4"
            style={{ fontFamily: "Playfair Display, serif" }}
          >
            PRAISE FOR THINK BEFORE YOU THINK
          </p>

          <div className="grid md:grid-cols-3 gap-10">
            {/* quote 1 */}
            {/* <div>
              <p
                className="text-5xl text-gray-300 leading-none mb-0"
                style={{ fontFamily: "Playfair Display, serif" }}
              >
                “
              </p>

              <p
                className="text-gray-700 mb-12"
                style={{ fontFamily: "Playfair Display, serif" }}
              >
                Adrian Owen is not just one of our top scientists, but a great storyteller. 
              </p>

              <p
                className="text-sm text-gray-500"
                style={{ fontFamily: "Playfair Display, serif" }}
              >
                — Daniel Levitin
              </p>

              <p
                className="text-xs text-gray-400"
                style={{ fontFamily: "Playfair Display, serif" }}
              >
                Author of This Is Your Brain on Music
              </p>
            </div> */}

            {/* quote 2 */}
            <div>
              <p
                className="text-5xl text-gray-300 leading-none mb-0"
                style={{ fontFamily: "Playfair Display, serif" }}
              >
                “
              </p>

              <p
                className="text-gray-700 mb-6"
                style={{ fontFamily: "Playfair Display, serif" }}
              >
                A fascinating journey into the human mind. Think Before You
                Think provides a priceless blueprint for a brighter future.
              </p>

              <p
                className="text-sm text-gray-500"
                style={{ fontFamily: "Playfair Display, serif" }}
              >
                — Richard Wiseman
              </p>

              <p
                className="text-xs text-gray-400"
                style={{ fontFamily: "Playfair Display, serif" }}
              >
                Author of 59 Seconds
              </p>
            </div>

            <div>
              <p
                className="text-5xl text-gray-300 leading-none mb-0"
                style={{ fontFamily: "Playfair Display, serif" }}
              >
                “
              </p>

              <p
                className="text-gray-700 mb-12"
                style={{ fontFamily: "Playfair Display, serif" }}
              >
                Adrian Owen is not just one of our top scientists, but a great
                storyteller.
              </p>

              <p
                className="text-sm text-gray-500"
                style={{ fontFamily: "Playfair Display, serif" }}
              >
                — Daniel Levitin
              </p>

              <p
                className="text-xs text-gray-400"
                style={{ fontFamily: "Playfair Display, serif" }}
              >
                Author of This Is Your Brain on Music
              </p>
            </div>

            {/* quote 3 */}
            <div>
              <p
                className="text-5xl text-gray-300 leading-none mb-0"
                style={{ fontFamily: "Playfair Display, serif" }}
              >
                “
              </p>

              <p
                className="text-gray-700 mb-6"
                style={{ fontFamily: "Playfair Display, serif" }}
              >
                A captivating, lucid and empowering read that shows, in this
                turbulent world, our executive functions may be our most
                underused superpower.
              </p>

              <p
                className="text-sm text-gray-500"
                style={{ fontFamily: "Playfair Display, serif" }}
              >
                — Roger Highfield
              </p>

              <p
                className="text-xs text-gray-400"
                style={{ fontFamily: "Playfair Display, serif" }}
              >
                Science Director, Science Museum London
              </p>
            </div>
          </div>
        </div>
      </section>

      <BooksFooter />
    </div>
  );
};

export default Books;
